export const NAV_LINKS = [
    { label: 'Home', to: '/' },
    { label: 'About Us', to: '/about-us' },
    { label: 'Services', to: '/services' },
    { label: 'Industries', to: '/industries' },
    { label: 'Competencies', to: '/competencies' },
    { label: 'Case Studies', to: '/case-studies' },
    { label: 'Newsroom', to: '/newsroom' },
    { label: 'Careers', to: '/careers' },
    { label: 'FAQ', to: '/faq' },
    { label: 'Contact Us', to: '/contact-us' },
];
